import { render, staticRenderFns } from "./select-requirement.vue?vue&type=template&id=55256d29&"
import script from "./select-requirement.vue?vue&type=script&lang=js&"
export * from "./select-requirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports